<style>
.v-select {
  border: 1px solid #d5d5d5;
}

.v-select.single.open .selected-tag {
  position: static;
}

.v-select.single .selected-tag {
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
}
.v-select .selected-tag {
  margin: 0 2px 0;
  color: #000 !important;
}

.v-select .dropdown-menu li.active {
  pointer-events: all;
}

.v-select .dropdown-toggle .vs__actions .clear {
  display: none;
}

.v-select .dropdown-toggle {
  padding: 10px 0;
  border-radius: 0px;
}

.v-select .open-indicator {
  width: 20px;
}

.v-select .dropdown-menu {
  min-width: initial;
  border: 2px solid #d5d5d5;
  border-top: 0;
  padding: 0;
  border-radius: 0;
}

.v-select .dropdown-menu li {
  font-size: 15px;
  padding: 14px 0;
}

.v-select .dropdown-menu li.active a {
  font-weight: 900;
}

.v-select__steel {
  border: none;
  z-index: 101;
}
.v-select__steel .dropdown-toggle {
  border: 2px solid #888; /* TODO: nog overzien */
}

.v-select .vs__selected-options {
  align-items: center;
}
</style>
<template>
  <div class="wpb_content specify">
    <div class="specify-content">
      <h2>RESTVOORRAAD</h2>
      <p>Bestellingen plaatsen vanuit onze restvoorraad</p>
      <div class="lead">
        <p style="color: #808080; text-transform: none">
          Bekijk onze actuele restvoorraad en bestel de gewenste producten. Alle
          materialen zijn direct leverbaar (onder voorbehoud van tussentijdse
          verkoop).
        </p>
      </div>
      <form
        action=""
        id="specify-free"
        class="specify-form"
        enctype="multipart/form-data"
      >
        <div class="form-label lg-select no-padding">
            <strong>KIES EEN KWALITEIT</strong>
            <v-select
                class="v-select v-select__steel"
                v-model="selectedCategory"
                :options="qualityTypeLabels"
                :searchable="false"
            >
            </v-select>
        </div>

        <div class="specify-form-row clearfix">
          <div class="form-label md-select">
            <strong>VORM</strong>
            <v-select
              class="v-select v-select__steel"
              v-if="selectedCategory"
              v-model="selectedShape"
              :disabled="shapeOptions.length === 1"
              :options="shapeOptions"
              :searchable="false"
            >
            </v-select>
          </div>
        </div>
        <div class="form-label">
          <strong style="margin-top: 30px">MAAT</strong>
          <div class="measurement-dropdown clearfix">
            <v-select
              class="v-select"
              v-if="selectedCategory"
              v-model="selectedProduct"
              index="product"
              :disabled="measurementOptions.length === 1"
              :options="measurementOptions"
              :searchable="false"
              @change="calculateAmount"
            >
            </v-select>
          </div>
        </div>
        <div class="specify-form-row clearfix" style="margin-top: 30px"></div>
      </form>
    </div>
    <aside class="right-sidebar">
      <div class="right-bar-sticky-container">
        <div v-if="selectedProduct" class="right-bar-inner">
          <div class="right-bar-section heading-area">
            <p class="code">
              {{ selectedProduct.type }}
            </p>
            <p class="heading">
              {{ selectedProduct.quality }}
            </p>
          </div>

          <div v-if="selectedProductIsRound" class="right-bar-section">
            <h6>MAAT</h6>
            <p>
              <span>Diameter</span
              ><span>{{ selectedProduct.width_or_diameter }} mm</span>
            </p>
            <p>
              <span>Lengte</span><span>{{ selectedProduct.length }} mm</span>
            </p>
          </div>
          <div v-else class="right-bar-section">
            <h6>MAAT</h6>
            <p>
              <span>Breedte</span
              ><span>{{ selectedProduct.width_or_diameter }} mm</span>
            </p>
            <p>
              <span>Dikte</span><span>{{ selectedProduct.thickness }} mm</span>
            </p>
            <p>
              <span>Lengte</span><span>{{ selectedProduct.length }} mm</span>
            </p>
          </div>

          <div class="right-bar-section">
            <h6>VORM & AANTAL</h6>
            <p>
              <span>Vorm</span>
              <span>
                {{ selectedProduct.shape }}
              </span>
            </p>
            <p>
              <span>Aantal</span>
              <v-select
                class="v-select form-label md-select residual-product-amount"
                v-model="amount"
                :options="amountOptions"
                :searchable="false"
                :disabled="amountOptions.length == 1 ? true : false"
              ></v-select>
            </p>

            <p>
              <span>Circa gewicht</span
              ><span>{{ selectedProduct.weight }} kg</span>
            </p>
            <p v-if="selectedProduct.price">
              <span>Stukprijs</span
              ><span class="value">&euro; {{ selectedProduct.price }}</span>
            </p>
          </div>
        </div>

        <button
          class="specify-btn"
          v-bind:disabled="posting"
          @click="submitForm()"
        >
          BESTEL
        </button>
      </div>
    </aside>
  </div>
</template>
<script>
let auth = document.head.querySelector('meta[name="auth"]').content;

import customerFreeFillable from "./helpers/vrij/customer";
import guestFreeFillable from "./helpers/vrij/guest";

import vSelect from "vue-select";

let mixin = guestFreeFillable;

if (parseInt(auth)) {
  mixin = customerFreeFillable;
}

export default {
  mixins: [mixin],
  components: {
    "v-select": vSelect,
  },
  props: ["products", "customer"],

  data: function () {
    return {
      possibleShapes: {
        Plat: "Flat",
        Rond: "Round",
        Voorbewerkt: "Preprocessed",
        "Plat - voorbewerkt": "Preprocessed",
        "Plat - ruw": "Preprocessed",
      },
      selectedCategory: null,
      selectedShape: null,
      selectedProduct: null,
      posting: false,
      amount: 1,
      amountOptions: [],
      guestOrderLines: [],
    };
  },

  mounted: function () {
    //on mount set the first product as the selected one
    this.selectedCategory = Object.keys(this.products)[0];
  },

  watch: {
    shapeOptions: function (options) {
      this.selectedShape = options[0];
    },

    measurementOptions: function (options) {
      this.selectedProduct = options[0].product;
      this.amountOptions = [];
      for (
        let i = 1;
        i <= this.selectedProduct.amount - this.selectedProduct.ordered;
        i++
      ) {
        this.amountOptions.push(i);
      }
    },
  },

  computed: {
    qualityTypeLabels: function () {
      return Object.keys(this.products);
    },

    shapeOptions: function () {
      if (!this.selectedCategory) return;

      return this.products[this.selectedCategory]
        .map(function (product) {
          return product.shape;
        })
        .concat("Alles")
        .reverse()
        .filter((value, index, self) => self.indexOf(value) == index);
    },

    orderedProducts: function () {
      return _.orderBy(this.products[this.selectedCategory], [
        "thickness",
        "width_or_diameter",
        "length",
      ]);
    },

    measurementOptions: function () {
      if (!this.selectedCategory || !this.selectedShape) return;

      if (this.selectedShape == "Alles") {
        return this.orderedProducts.map(function (product) {
          return {
            label:
              this["formatProductLabel" + this.possibleShapes[product.shape]](
                product
              ),
            product: product,
          };
        }, this);
      }

      return this.orderedProducts
        .filter((product) => product.shape === this.selectedShape)
        .map(function (product) {
          return {
            label:
              this["formatProductLabel" + this.possibleShapes[product.shape]](
                product
              ),
            product: product,
          };
        }, this);
    },

    selectedProductIsRound: function () {
      return this.selectedProduct.shape === "Rond";
    },
  },

  methods: {
    submitForm: function () {
      if (this.customer) {
        this.postItemUser(0);
      } else {
        let _this = this;
        setTimeout(function () {
          _this.postItemGuest(0);
          _this.saveGuestShoppingCart();
          _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
          _this.posting = false;
        }, 1000);
      }
    },

    postItemUser: function (orderOrOffer) {
      this.orderOrOffer = orderOrOffer;

      this.posting = true;

      let url = "/order-line/store";

      if (this.orderLine !== undefined) {
        url = "/order-line/update/" + this.orderLine.id;
      }

      let _this = this;

      axios
        .post(url, {
          product: this.selectedProduct.id,
          category: this.selectedProduct.id,
          amount: 1,
          shape: this.selectedProduct.shape_code,
          amount: this.amount,
          orderOrOffer: 0,
          free: false,
          is_residual: true,
        })
        .then(function (response) {
          _this.posting = false;
          _this.$awn.success("Uw product is toegevoegd aan de winkelwagen!");
          if (_this.orderLine === undefined) {
            window.incrementShoppingCart();
          }
        }, _this)
        .catch(function (error) {
          _this.posting = false;
          _this.$awn.alert(
            "Oeps, daar ging iets mis, probeert u het later nog eens"
          );
        }, _this);
    },

    postItemGuest: function (orderOrOffer) {
      let _this = this;
      let elementFound = 0;

      let params = [_this, orderOrOffer];

      if (this.guestOrderLines.length > 0) {
        this.guestOrderLines.forEach(function (element) {
          if (
            params[0].selectedProduct.id === element.product_id &&
            params[1] === element.order_offer
          ) {
            elementFound = 1;
          }
        }, params);
      }
      if (!elementFound) {
        let object = {
          id: this.guestOrderLines.length + 1,
          product_id: this.selectedProduct.id,
          category_id: null,
          order_offer: orderOrOffer,
          article: null,
          steel_name: this.selectedProduct.type,
          steel_type: this.selectedProduct.quality,
          pieces: this.amount,
          price_per_piece: this.selectedProduct.price,
          shape_code: this.selectedProduct.shape,
          length: this.selectedProduct.length,
          width: this.selectedProduct.width_or_diameter,
          thickness: this.selectedProduct.thickness,
          is_residual_product: true,
        };

        window.incrementShoppingCart();

        this.guestOrderLines.push(object);
      }
    },
    calculateAmount: function() {
        for (let i = 2; i <= this.selectedProduct.amount - this.selectedProduct.ordered; i++ ) {
            this.amountOptions.push(i);
        }
    },
    saveGuestShoppingCart: function () {
      localStorage.setItem(
        "guestShoppingcart",
        JSON.stringify(this.guestOrderLines)
      );
      $("#guestShoppingcart").val(localStorage.getItem("guestShoppingcart"));
    },

    formatProductLabelRound: function (product) {
      return (
        "Ø: " +
        product.width_or_diameter +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "L: " +
        product.length +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "G: " +
        product.weight +
        " kg" +
        "\xa0\xa0\xa0\xa0" +
        "Vorm: " +
        product.shape
      );
    },

    formatProductLabelPreprocessed: function (product) {
      return (
        "D: " +
        product.thickness +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "B: " +
        product.width_or_diameter +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "L: " +
        product.length +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "G: " +
        product.weight +
        " kg" +
        "\xa0\xa0\xa0\xa0" +
        "Vorm: " +
        product.shape
      );
    },

    formatProductLabelFlat: function (product) {
      return (
        "D: " +
        product.thickness +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "B: " +
        product.width_or_diameter +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "L: " +
        product.length +
        " mm" +
        "\xa0\xa0\xa0\xa0" +
        "G: " +
        product.weight +
        " kg" +
        "\xa0\xa0\xa0\xa0" +
        "Vorm: " +
        product.shape
      );
    },
  },
};
</script>

<style>
.dropdown-menu li.active {
  display: none;
}
.v-select .dropdown-toggle {
  min-height: 50px;
}

.v-select.open .selected-tag {
  /* margin-top:12px; */
}

.v-select.single.open .selected-tag {
  position: static;
}

.v-select.single .selected-tag {
  position: absolute;
  margin: 0;
  top: 15%;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
  width: 100%;
}
.v-select .selected-tag {
  margin: 0 2px 0;
  color: #000 !important;
}

.v-select .dropdown-toggle .vs__actions .clear {
  display: none;
}

.v-select .dropdown-toggle {
  border-radius: 0px;
}

.v-select {
  border: 1px solid #d5d5d5;
}

.v-select .open-indicator {
  width: 20px;
}

.measurement-dropdown {
  margin-right: 0;
}

@media screen and (min-width: 768px) {
  .measurement-dropdown {
    margin-right: 14px;
  }
}

.measurement-dropdown .dropdown,
.measurement-dropdown .dropdown-toggle {
  border-color: #075096;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/product/residual-stock.vue